module.exports = __webpack_public_path__ + "img/section9.e6462d92.png";